import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { RoutedByIndicatorContent } from "@ryde/controls";
import { useCrudEditContext } from "@ryde/redux";
import {
  CourseFormFields,
  CourseMetadataKeys,
  editFormDataAF,
  EditFormMode,
  ICourseDto,
  resolveDirectionsServiceLabel,
  useFormats,
} from "@ryde/shared";

import {
  CourseBottomBlockStyled,
  CourseTabsBottomBlocksStyled,
} from "./course.styled";

export const CourseTabsBottomBlocks: FC = () => {
  const { entity, mode } = useCrudEditContext<ICourseDto>();
  // editFormDataAF is untyped (any); annotate local value instead of casting.
  const courseDto: ICourseDto | undefined = useRecoilValue(
    editFormDataAF([entity, mode || EditFormMode.CrudRoute]),
  );
  const { formatDateTimeNormalized } = useFormats();
  const { t } = useTranslation();
  const { watch } = useFormContext<ICourseDto>();
  const isManualPolylineEditFromForm = watch(
    CourseFormFields.isManualPolylineEdit,
  );
  const isManualPolylineEdit =
    courseDto?.metadata?.[CourseMetadataKeys.isManualPolylineEdit] === true ||
    isManualPolylineEditFromForm === true;
  const createdAt = formatDateTimeNormalized(courseDto?.createdAt);
  const updatedAt = formatDateTimeNormalized(courseDto?.updatedAt);
  const routedByLabel = resolveDirectionsServiceLabel(
    courseDto?.metadata?.directionsService,
  );

  return (
    <CourseTabsBottomBlocksStyled>
      <CourseBottomBlockStyled>
        <label>{t("general.CREATED_AT")}</label>
        <span>{createdAt}</span>
      </CourseBottomBlockStyled>
      <CourseBottomBlockStyled>
        <label>{t("general.UPDATED_AT")}</label>
        <span>{updatedAt}</span>
      </CourseBottomBlockStyled>
      {!isManualPolylineEdit && !!routedByLabel && (
        <CourseBottomBlockStyled>
          <RoutedByIndicatorContent
            directionsService={courseDto?.metadata?.directionsService}
          />
        </CourseBottomBlockStyled>
      )}
    </CourseTabsBottomBlocksStyled>
  );
};
